import Request from 'superagent';

export const getStaticContent = (type: string, versionNumber: number): Promise => {
    return Request.get(`/api/get-static-content?typeContent=${type}${versionNumber ? `&versionNumber=${versionNumber}` : ''}`);
};

export const getOverageInvoice = (invoiceNumber: string): Promise => {
    return Request.get(`/api/invoices-by-invoice-number/${invoiceNumber}`);
};